import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { UtentiPage } from '../utenti/utenti';

/**
 * Generated class for the AddutentePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-addutente',
  templateUrl: 'addutente.html',
})
export class AddutentePage {
  esito;
  errorMessage;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    private readonly loadingCtrl: LoadingController,
    public rest: RestApiProvider,
  ) {
  }

  newUser(values: any) {
    let loading = this.loadingCtrl.create({

      spinner: 'bubbles',
      duration: 2000,

      content: 'save utente store ...'

    });

    loading.present();
    this.rest.nuovoUtenteStore(values).subscribe(
      esito => {
        this.esito = esito;
        if (esito != null && esito.risposta == "EXISTS") {
          loading.dismiss();
          alert("Username esite già");

        }
        else {
          loading.dismiss();
          this.navCtrl.push(UtentiPage);

        }
      },
      error => this.errorMessage = <any>error);

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AddutentePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/addutente/addutente.ts